<script setup lang="ts">
import type { CmsElementIconWithText } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementIconWithText;
  class: any;
  style: any;
}>();

const { heading, iconWithText } = props.content?.config
</script>
<template>
  <section class="section section-features section-main" :style="props.style" :class="props.class">
    <div class="container">
      <header class="section__head">
        <h2>{{ heading.value }}</h2>
      </header><!-- /.section__head -->

      <div class="section__body">
        <div class="features-secondary section__features">
          <div class="row">
            <div class="col-6 col-md-3" v-for="(feature, index) in iconWithText.value">
              <div class="feature features__feature">
                <div class="feature__image">
                  <NuxtImg format="webp" loading="lazy" :src="feature.icon?.url" alt="" width="153" height="136"></NuxtImg>
                </div><!-- /.feature__image -->

                <div class="feature__content">
                  <p>{{ feature.text }}</p>
                </div><!-- /.feature__content -->
              </div>
            </div>
          </div>
        </div><!-- /.features-/-secondary section__features -->
      </div><!-- /.section__body -->
    </div><!-- /.container -->
  </section>
</template>